import { inject, Injectable } from '@angular/core';
import { SessionService } from '../../services';
import { DynamicFilters, ReportRequestBodyStrategy } from '../../interfaces';
import moment from 'moment/moment';

@Injectable({ providedIn: 'root' })
export class VerificationRequestBodyStrategy
  implements ReportRequestBodyStrategy
{
  sessionService = inject(SessionService);
  csvLimit = 10000000;
  pageLimit = 100;

  buildRequestBody(config: any): ReportRequestBodyStrategy {
    const {
      offset = 0,
      limit,
      allFilters,
      formData,
      columns,
      executionType,
      isGrandTotal = false,
      sorting,
      template,
    } = config;

    const result: any = {
      p_columns: columns,
      p_additional_params: {},
      p_tracing_info: {
        p_template_name: template ? template.template_name : null,
        p_template_id: template ? template.template_id : null,
        p_user_id: this.sessionService.sessionData?.Username,
      },
      p_advanced_filtering: {
        p_offset: offset || 0,
        p_limit:
          executionType === 'csv_load'
            ? this.csvLimit
            : limit === null
            ? this.pageLimit
            : limit,
        p_order_by: sorting?.field || null,
        p_order_by_asc_desc: sorting?.value || null,
      },
      p_is_grandtotal: isGrandTotal,
      p_execution_type: executionType,
      p_columns_mask: null,
      p_show_last_verification: formData.show_last_verification,
    };

    allFilters.forEach((field: DynamicFilters) => {
      const { field_id, is_default } = field;
      if (field_id === 'documents') {
        return;
      }

      let value;
      if (field_id === 'merchant') {
        value = formData['merchant_name'] ?? null;
      } else {
        value = formData[field_id] ?? null;
      }
      const prefixedKey =
        field_id === 'merchant_name' ? 'p_domains' : `p_${field_id}`;

      if (field.field_data_type === 'TIMESTAMP' && value) {
        const { start, end } = value;
        if (start && end) {
          value = [
            moment(start).format('YYYY-MM-DD HH:mm:ss.SSS'),
            moment(end).format('YYYY-MM-DD HH:mm:ss.SSS'),
          ];
        }
      }
      if (is_default === 'true') {
        result[prefixedKey] = value;
      } else {
        result.p_additional_params[prefixedKey] = value;
      }
    });

    return result;
  }
}
